var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArtisanGrid',{ref:"SysMenuInfo",attrs:{"metaKey":"SysMenuInfo","leftOption":_vm.option,"confirmAfter":_vm.loadTreeData,"delRowAfter":_vm.loadTreeData},scopedSlots:_vm._u([{key:"icon",fn:function({ row }){return [_c('i',{class:row.icon})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }